import { gql } from "@apollo/client";

const DELETE_PRICELIST = gql`
  mutation deletePricelist($articlePriceListId: Int!) {
    companyAdminContext {
      pricelists {
        deletePricelist(articlePriceListId: $articlePriceListId) {
          errorResult {
            errorMessage
          }
          success
        }
      }
    }
  }
`;

export default DELETE_PRICELIST;